<!-- editActive->{{editActive}} -->

<form class="content-general" [formGroup]="formGroup">
  <div class="general">
    <!-- BUTTONS -->
    <div class="buttons">
      <button
        *ngIf="editActive || isNewForm"
        (click)="onSubmit()"
        [disabled]="!this.formGroup.valid"
        class="changes btn-style flex justify-content-center align-items-center me-1"
      >
        <span class="material-symbols-outlined icon-style"> save </span>
        <span class="text-sm">Save</span>
      </button>
      <button
        *ngIf="editActive || isNewForm"
        (click)="cancelEditForm()"
        class="btn-style flex justify-content-center align-items-center me-1"
      >
        <span class="material-symbols-outlined icon-style"> cancel </span>
        <span class="text-sm">Cancel</span>
      </button>
      <button
        *ngIf="!isNewForm && !editActive"
        (click)="activeEditForm()"
        class="btn-style flex justify-content-center align-items-center me-1"
      >
        <span class="material-symbols-outlined icon-style"> edit </span>
        <span class="text-sm">Edit</span>
      </button>
      <button
        *ngIf="!isNewForm && !editActive"
        [ngClass]="{ 'mg-button-selected': isPreview }"
        (click)="previewLayout()"
        class="btn-style flex justify-content-center align-items-center me-1"
      >
        <span
          [ngClass]="{ 'mg-button-icon-selected': isPreview }"
          class="material-symbols-outlined icon-style"
        >
          visibility
        </span>
        <span
          [ngClass]="{ 'mg-button-icon-selected': isPreview }"
          class="text-sm"
          >Preview</span
        >
      </button>
      <button
        *ngIf="
          elementSelected &&
          elementSelected.pk == 'form' &&
          !isNewForm &&
          !editActive
        "
        (click)="onPublish()"
        class="btn-style flex justify-content-center align-items-center me-1"
      >
        <span class="material-symbols-outlined icon-style">
          rocket_launch
        </span>
        <span class="text-sm">Publish</span>
      </button>
      <button
        *ngIf="
          elementSelected &&
          elementSelected.pk == 'form' &&
          !isNewForm &&
          !editActive
        "
        (click)="onClone()"
        class="btn-style flex justify-content-center align-items-center me-1"
      >
        <span class="material-symbols-outlined icon-style"> content_copy </span>
        <span class="text-sm">Clone</span>
      </button>

      <button
        (click)="deleteForm()"
        style="margin-left: auto"
        *ngIf="elementSelected && !isNewForm && !editActive"
        class="btn-style btn-danger flex justify-content-center align-items-center me-1"
      >
        <span class="material-symbols-outlined icon-style"> delete </span>
        <span class="text-sm">Delete</span>
      </button>
    </div>

    <div class="form" [ngClass]="{ hide: this.isPreview }">
      <div class="initial-form">
        <!-- NAME -->
        <div class="form-key">
          <label for=""
            ><strong>Name<span class="required-field">*</span></strong></label
          >
          <input
            class="form-control"
            type="text"
            formControlName="name"
            *ngIf="editActive || isNewForm"
          />
          <div
            class="alert-title"
            *ngIf="
              formGroup.get('name') &&
              formGroup.get('name').invalid &&
              (formGroup.get('name').dirty || formGroup.get('name').touched)
            "
          >
            <span class="error" *ngIf="formGroup.get('name')?.errors?.required">
              Required field.
            </span>
          </div>
          <span *ngIf="!editActive && !isNewForm">
            {{ elementSelected?.name }}
          </span>
        </div>

        <!-- TITLE -->
        <div class="form-key">
          <label for=""
            ><strong>Title<span class="required-field">*</span></strong></label
          >
          <input
            class="form-control"
            type="text"
            formControlName="title"
            *ngIf="editActive || isNewForm"
          />
          <div
            class="alert-title"
            *ngIf="
              formGroup.get('title') &&
              formGroup.get('title').invalid &&
              (formGroup.get('title').dirty || formGroup.get('title').touched)
            "
          >
            <span
              class="error"
              *ngIf="formGroup.get('title')?.errors?.required"
            >
              Required field.
            </span>
          </div>
          <span *ngIf="!editActive && !isNewForm">
            {{ elementSelected?.title }}
          </span>
        </div>

        <!-- DESCRIPTION -->
        <div class="form-key">
          <label for=""><strong>Description</strong></label>
          <p-editor
            class="form-control"
            [style]="{ height: '150px' }"
            formControlName="description"
            *ngIf="editActive || isNewForm"
          ></p-editor>
          <span
            *ngIf="!editActive && !isNewForm"
            [innerHTML]="elementSelected?.description"
          >
          </span>
        </div>

        <!-- CONFIG -->
        <div class="" formGroupName="config">
          <div class="initial-form">
            <!-- ALERT MESSAGE -->
            <div class="form-key">
              <label for=""><strong>Alert Message</strong></label>
              <input
                class="form-control"
                type="text"
                formControlName="alert_message"
                *ngIf="editActive || isNewForm"
              />
              <span *ngIf="!editActive && !isNewForm">
                {{ elementSelected?.config?.alert_message }}
              </span>
            </div>

            <!-- FINAL MESSAGE -->
            <div class="form-key">
              <label for=""
                ><strong
                  >Final Message<span class="required-field">*</span></strong
                ></label
              >
              <input
                class="form-control"
                type="text"
                formControlName="final_message"
                *ngIf="editActive || isNewForm"
              />
              <div
                class="alert-title"
                *ngIf="
                  formGroup.get('config.final_message') &&
                  formGroup.get('config.final_message').invalid &&
                  (formGroup.get('config.final_message').dirty ||
                    formGroup.get('config.final_message').touched)
                "
              >
                <span
                  class="error"
                  *ngIf="
                    formGroup.get('config.final_message')?.errors?.required
                  "
                >
                  Required field.
                </span>
              </div>
              <span *ngIf="!editActive && !isNewForm">
                {{ elementSelected?.config?.final_message }}
              </span>
            </div>

            <div class="initial-form">
              <!-- MESSAGE OPTIONS -->
              <div class="form-key">
                <label for=""><strong>Message Options</strong></label>

                <div
                  *ngIf="editActive || isNewForm"
                  class="form-horizontal-checkboxes"
                >
                  <label class="label-checkbox">
                    <input
                      type="checkbox"
                      formControlName="final_message_hide"
                      id="final_message_hide"
                    />
                    Hide final meessage popup
                  </label>
                </div>

                <div
                  *ngIf="!editActive && !isNewForm"
                  class="form-horizontal-checkboxes"
                >
                  <div>
                    Hide final meessage popup:
                    <span
                      *ngIf="elementSelected.config.final_message_hide"
                      class="tag tag-success"
                      >Yes</span
                    ><span
                      *ngIf="!elementSelected.config.final_message_hide"
                      class="tag"
                      >No</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="custom-form">

        <!-- CUSTOM KEY -->
        <div class="form-key">
          <label for=""
            ><strong
              >Custom Key<span class="required-field">*</span></strong
            ></label
          >
          <input
            class="form-control"
            type="text"
            formControlName="custom_key"
            *ngIf="editActive || isNewForm"
            (keypress)="onKeyPress($event)"
          />
          <div
            class="alert-title"
            *ngIf="
              formGroup.get('custom_key') &&
              formGroup.get('custom_key').invalid &&
              (formGroup.get('custom_key').dirty ||
                formGroup.get('custom_key').touched)
            "
          >
            <span
              class="error"
              *ngIf="formGroup.get('custom_key')?.errors?.required"
            >
              Required field.
            </span>
            <span
              class="error"
              *ngIf="formGroup.get('custom_key')?.errors?.invalidSlug"
            >
              Only letters, numbers, underscores and hyphens are allowed.
            </span>
          </div>
          <span *ngIf="!editActive && !isNewForm">
            {{ elementSelected?.custom_key }}
          </span>
        </div>

        <!-- DATA ORDER -->
        <div class="data-order-section">
          <div class="form-key">
              <label for=""><strong>Data Order</strong></label>        

          <div
            class="data-order-list"
            formArrayName="orderable_properties"
            cdkDropList
            [cdkDropListData]="orderableProperties.controls"
            [cdkDropListDisabled]="!editActive && !isNewForm"
            (cdkDropListDropped)="dropOrder($event)"
          >
            <div
              class="data-order-item"
              *ngFor="let prop of orderableProperties.controls; let i = index"
              [formGroupName]="i"
              cdkDrag
            >
              <!-- Drag handle (edit mode only) -->
              <span
                *ngIf="editActive || isNewForm"
                class="drag-handle"
                cdkDragHandle
                title="Drag to reorder"
              >
                ☰
              </span>

              <!-- Label -->
              <span class="data-order-label">
                {{ prop.value.label }}
              </span>

              <!-- View-only order index -->
              <span
                *ngIf="!editActive && !isNewForm"
                class="order-index"
              >
                {{ i + 1 }}
              </span>
            </div>
          </div>
          </div>
        </div>


        <!-- CONFIG -->
        <div class="" formGroupName="config">
        
          <div class="initial-form">
            <!-- VOCALE OPTIONS -->
            <div class="form-key">
              <label for=""><strong>Vocale Options</strong></label>

              <div
                *ngIf="editActive || isNewForm"
                class="form-horizontal-checkboxes"
              >
                <label class="label-checkbox">
                  <input type="checkbox" formControlName="vocale" id="vocale" />
                  Activate Vocale
                </label>
              </div>

              <div
                *ngIf="!editActive && !isNewForm"
                class="form-horizontal-checkboxes"
              >
                <div>
                  Vocale active:
                  <span
                    *ngIf="elementSelected.config.vocale"
                    class="tag tag-success"
                    >Yes</span
                  ><span *ngIf="!elementSelected.config.vocale" class="tag"
                    >No</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="initial-form">
            <!-- PERSISTENCE OPTIONS -->
            <div class="form-key">
              <label for=""><strong>Persistence Options</strong></label>

              <div
                *ngIf="editActive || isNewForm"
                class="form-horizontal-checkboxes"
              >
                <label class="label-checkbox">
                  <input
                    type="checkbox"
                    formControlName="ignore_persistence"
                    id="ignore_persistence"
                  />
                  Data will not persist in Database (events only)
                </label>

                <label class="label-checkbox">
                  <input
                    type="checkbox"
                    formControlName="submit_unlocked"
                    id="submit_unlocked"
                  />
                  The form will not lock when submitting
                </label>
              </div>

              <div
                *ngIf="!editActive && !isNewForm"
                class="form-horizontal-checkboxes"
              >
                <div>
                  Ignore Persistence:
                  <span
                    *ngIf="elementSelected.config.ignore_persistence"
                    class="tag tag-success"
                    >Yes</span
                  ><span
                    *ngIf="!elementSelected.config.ignore_persistence"
                    class="tag"
                    >No</span
                  >
                </div>

                <div>
                  Multiple Submits:
                  <span
                    *ngIf="elementSelected.config.submit_unlocked"
                    class="tag tag-success"
                    >Yes</span
                  ><span
                    *ngIf="!elementSelected.config.submit_unlocked"
                    class="tag"
                    >No</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="initial-form">
            <!-- HEADER CONFIG -->
            <div class="form-key">
              <label for=""><strong>Header Options</strong></label>
              <div
                *ngIf="editActive || isNewForm"
                class="form-horizontal-checkboxes"
              >
                <label class="label-checkbox">
                  <input
                    type="checkbox"
                    formControlName="header_hide"
                    id="header_hide"
                  />
                  Hide All
                </label>

                <label class="label-checkbox">
                  <input
                    type="checkbox"
                    formControlName="header_hide_title"
                    id="header_hide_title"
                  />
                  Hide Title
                </label>

                <label class="label-checkbox">
                  <input
                    type="checkbox"
                    formControlName="header_hide_image"
                    id="header_hide_image"
                  />
                  Hide Image
                </label>

                <label class="label-checkbox">
                  <input
                    type="checkbox"
                    formControlName="header_sticky"
                    id="header_sticky"
                  />
                  Sticky
                </label>
              </div>

              <div
                *ngIf="!editActive && !isNewForm"
                class="form-horizontal-checkboxes"
              >
                <div>
                  Hide All:
                  <span
                    *ngIf="elementSelected.config.header_hide"
                    class="tag tag-success"
                    >Yes</span
                  ><span *ngIf="!elementSelected.config.header_hide" class="tag"
                    >No</span
                  >
                </div>
                <div>
                  Hide Title:
                  <span
                    *ngIf="elementSelected.config.header_hide_title"
                    class="tag tag-success"
                    >Yes</span
                  ><span
                    *ngIf="!elementSelected.config.header_hide_title"
                    class="tag"
                    >No</span
                  >
                </div>
                <div>
                  Hide Image:
                  <span
                    *ngIf="elementSelected.config.header_hide_image"
                    class="tag tag-success"
                    >Yes</span
                  ><span
                    *ngIf="!elementSelected.config.header_hide_image"
                    class="tag"
                    >No</span
                  >
                </div>
                <div>
                  Sticky:
                  <span
                    *ngIf="elementSelected.config.header_sticky"
                    class="tag tag-success"
                    >Yes</span
                  ><span
                    *ngIf="!elementSelected.config.header_sticky"
                    class="tag"
                    >No</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="initial-form">
            <!-- FOOTER CONFIG -->
            <div class="form-key">
              <label for=""><strong>Footer Options</strong></label>
              <div
                *ngIf="editActive || isNewForm"
                class="form-horizontal-checkboxes"
              >
                <label class="label-checkbox">
                  <input
                    type="checkbox"
                    formControlName="footer_hide"
                    id="footer_hide"
                  />
                  Hide All
                </label>

                <label class="label-checkbox">
                  <input
                    type="checkbox"
                    formControlName="footer_save_hide"
                    id="footer_save_hide"
                  />
                  Hide Save Button
                </label>

                <label class="label-checkbox">
                  <input
                    type="checkbox"
                    formControlName="footer_validate_hide"
                    id="footer_validate_hide"
                  />
                  Hide Validate Button
                </label>

                <label class="label-checkbox">
                  <input
                    type="checkbox"
                    formControlName="footer_submit_hide"
                    id="footer_submit_hide"
                  />
                  Hide Submit Button
                </label>

                <label class="label-checkbox">
                  <input
                    type="checkbox"
                    formControlName="footer_sticky"
                    id="footer_sticky"
                  />
                  Sticky
                </label>
              </div>

              <div
                *ngIf="!editActive && !isNewForm"
                class="form-horizontal-checkboxes"
              >
                <div>
                  Hide All:
                  <span
                    *ngIf="elementSelected.config.footer_hide"
                    class="tag tag-success"
                    >Yes</span
                  ><span *ngIf="!elementSelected.config.footer_hide" class="tag"
                    >No</span
                  >
                </div>
                <div>
                  Hide Save Button:
                  <span
                    *ngIf="elementSelected.config.footer_save_hide"
                    class="tag tag-success"
                    >Yes</span
                  ><span
                    *ngIf="!elementSelected.config.footer_save_hide"
                    class="tag"
                    >No</span
                  >
                </div>
                <div>
                  Hide Validate Button:
                  <span
                    *ngIf="elementSelected.config.footer_validate_hide"
                    class="tag tag-success"
                    >Yes</span
                  ><span
                    *ngIf="!elementSelected.config.footer_validate_hide"
                    class="tag"
                    >No</span
                  >
                </div>
                <div>
                  Hide Submit Button:
                  <span
                    *ngIf="elementSelected.config.footer_submit_hide"
                    class="tag tag-success"
                    >Yes</span
                  ><span
                    *ngIf="!elementSelected.config.footer_submit_hide"
                    class="tag"
                    >No</span
                  >
                </div>
                <div>
                  Sticky:
                  <span
                    *ngIf="elementSelected.config.footer_sticky"
                    class="tag tag-success"
                    >Yes</span
                  ><span
                    *ngIf="!elementSelected.config.footer_sticky"
                    class="tag"
                    >No</span
                  >
                </div>
              </div>
            </div>

            <!-- SAVE BUTTON TEXT -->
            <div class="form-key">
              <label for=""
                ><strong>Save Button Text</strong>

                <span *ngIf="!editActive && !isNewForm" class="tag">
                  <ng-container
                    *ngIf="
                      elementSelected.config.save_text &&
                      elementSelected.config.save_text != ''
                    "
                  >
                    {{ elementSelected.config.save_text }}</ng-container
                  >
                  <ng-container
                    *ngIf="
                      !elementSelected.config.save_text ||
                      elementSelected.config.save_text == ''
                    "
                  >
                    Save</ng-container
                  >
                </span>
              </label>
              <input
                class="form-control"
                type="text"
                placeholder="Save"
                formControlName="save_text"
                *ngIf="editActive || isNewForm"
              />
              <div
                class="alert-title"
                *ngIf="
                  formGroup.get('save_text') &&
                  formGroup.get('save_text').invalid &&
                  (formGroup.get('save_text').dirty ||
                    formGroup.get('save_text').touched)
                "
              >
                <span
                  class="error"
                  *ngIf="formGroup.get('save_text')?.errors?.required"
                >
                  Required field.
                </span>
              </div>
            </div>

            <!-- VALIDATE BUTTON TEXT -->
            <div class="form-key">
              <label for=""
                ><strong>Validate Button Text</strong>

                <span *ngIf="!editActive && !isNewForm" class="tag">
                  <ng-container
                    *ngIf="
                      elementSelected.config.validate_text &&
                      elementSelected.config.validate_text != ''
                    "
                  >
                    {{ elementSelected.config.validate_text }}</ng-container
                  >
                  <ng-container
                    *ngIf="
                      !elementSelected.config.validate_text ||
                      elementSelected.config.validate_text == ''
                    "
                  >
                    Save</ng-container
                  >
                </span>
              </label>
              <input
                class="form-control"
                type="text"
                placeholder="Validate"
                formControlName="validate_text"
                *ngIf="editActive || isNewForm"
              />
              <div
                class="alert-title"
                *ngIf="
                  formGroup.get('validate_text') &&
                  formGroup.get('validate_text').invalid &&
                  (formGroup.get('validate_text').dirty ||
                    formGroup.get('validate_text').touched)
                "
              >
                <span
                  class="error"
                  *ngIf="formGroup.get('validate_text')?.errors?.required"
                >
                  Required field.
                </span>
              </div>
            </div>

            <!-- SUBMIT BUTTON TEXT -->
            <div class="form-key">
              <label for=""
                ><strong>Submit Button Text</strong>

                <span *ngIf="!editActive && !isNewForm" class="tag">
                  <ng-container
                    *ngIf="
                      elementSelected.config.submit_text &&
                      elementSelected.config.submit_text != ''
                    "
                  >
                    {{ elementSelected.config.submit_text }}</ng-container
                  >
                  <ng-container
                    *ngIf="
                      !elementSelected.config.submit_text ||
                      elementSelected.config.submit_text == ''
                    "
                  >
                    Save</ng-container
                  >
                </span>
              </label>
              <input
                class="form-control"
                type="text"
                placeholder="Submit"
                formControlName="submit_text"
                *ngIf="editActive || isNewForm"
              />
              <div
                class="alert-title"
                *ngIf="
                  formGroup.get('submit_text') &&
                  formGroup.get('submit_text').invalid &&
                  (formGroup.get('submit_text').dirty ||
                    formGroup.get('submit_text').touched)
                "
              >
                <span
                  class="error"
                  *ngIf="formGroup.get('submit_text')?.errors?.required"
                >
                  Required field.
                </span>
              </div>
            </div>

            <!-- TO TEMPLATE BUTTON TEXT -->
            <div class="form-key">
              <label for=""
                ><strong>To Template Button Text</strong>

                <span *ngIf="!editActive && !isNewForm" class="tag">
                  <ng-container
                    *ngIf="
                      elementSelected.config.to_template_text &&
                      elementSelected.config.to_template_text != ''
                    "
                  >
                    {{ elementSelected.config.to_template_text }}</ng-container
                  >
                  <ng-container
                    *ngIf="
                      !elementSelected.config.to_template_text ||
                      elementSelected.config.to_template_text == ''
                    "
                  >
                    To Template</ng-container
                  >
                </span>
              </label>
              <input
                class="form-control"
                type="text"
                placeholder="To Template"
                formControlName="to_template_text"
                *ngIf="editActive || isNewForm"
              />
              <div
                class="alert-title"
                *ngIf="
                  formGroup.get('to_template_text') &&
                  formGroup.get('to_template_text').invalid &&
                  (formGroup.get('to_template_text').dirty ||
                    formGroup.get('to_template_text').touched)
                "
              >
                <span
                  class="error"
                  *ngIf="formGroup.get('to_template_text')?.errors?.required"
                >
                  Required field.
                </span>
              </div>
            </div>

            <!--NOTES BUTTON TEXT -->

            <div class="form-key">
              <label for=""
                ><strong>Notes Button Text</strong>

                <span *ngIf="!editActive && !isNewForm" class="tag">
                  <ng-container
                    *ngIf="
                      elementSelected.config.notes_text &&
                      elementSelected.config.notes_text != ''
                    "
                  >
                    {{ elementSelected.config.notes_text }}</ng-container
                  >
                  <ng-container
                    *ngIf="
                      !elementSelected.config.notes_text ||
                      elementSelected.config.notes_text == ''
                    "
                  >
                    Notes</ng-container
                  >
                </span>
              </label>
              <input
                class="form-control"
                type="text"
                placeholder="Notes"
                formControlName="notes_text"
                *ngIf="editActive || isNewForm"
              />
              <div
                class="alert-title"
                *ngIf="
                  formGroup.get('notes_text') &&
                  formGroup.get('notes_text').invalid &&
                  (formGroup.get('notes_text').dirty ||
                    formGroup.get('notes_text').touched)
                "
              >
                <span
                  class="error"
                  *ngIf="formGroup.get('notes_text')?.errors?.required"
                >
                  Required field.
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- PDF EVENTS -->
        <div formArrayName="pdf_events">
          <div class="form-key">
            <label for=""><strong>Generate PDF On</strong></label>
            <div
              *ngIf="editActive || isNewForm"
              class="form-horizontal-checkboxes"
            >
              <label
                class="label-checkbox"
                *ngFor="let choice of pdf_events.controls; let i = index"
              >
                <input type="checkbox" [formControlName]="i" />
                {{ pdfEvents[i].label }}
              </label>
            </div>

            <div *ngIf="!editActive && !isNewForm">
              <div
                *ngIf="
                  elementSelected.pdf_events &&
                  elementSelected.pdf_events.length > 0
                "
              >
                <span
                  *ngFor="let tag of elementSelected.pdf_events"
                  class="tag"
                  >{{ getPdfEventNameById(tag) }}</span
                >
              </div>
              <div
                *ngIf="
                  !elementSelected.pdf_events ||
                  elementSelected.pdf_events.length == 0
                "
              >
                <span class="tag">Never</span>
              </div>
            </div>
          </div>
        </div>

        <!-- TEMPLATE -->
        <div class="" formGroupName="template">
          <div class="initial-form">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="title-templates">
                  <strong>Templates</strong>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <!-- EMAIL -->
              <div class="form-key-h mt-2">
                <label class="form-template-label"
                  ><strong>Email:</strong></label
                >
                <input
                  class="form-control input-mango-form"
                  type="text"
                  placeholder="Template"
                  formControlName="email"
                  *ngIf="editActive || isNewForm"
                />
                <span *ngIf="!editActive && !isNewForm">
                  {{ elementSelected?.template?.email }}
                </span>
              </div>
              <!-- SMS -->
              <div class="form-key-h mt-2">
                <label class="form-template-label"><strong>SMS:</strong></label>
                <input
                  class="form-control input-mango-form"
                  type="text"
                  placeholder="Template"
                  formControlName="sms"
                  *ngIf="editActive || isNewForm"
                />
                <span *ngIf="!editActive && !isNewForm">
                  {{ elementSelected?.template?.sms }}
                </span>
              </div>
              <!-- CODE -->
              <div class="form-key-h mt-2">
                <label class="form-template-label"
                  ><strong>Code:</strong></label
                >
                <input
                  class="form-control input-mango-form"
                  type="text"
                  placeholder="Template"
                  formControlName="code"
                  *ngIf="editActive || isNewForm"
                />
                <span *ngIf="!editActive && !isNewForm">
                  {{ elementSelected?.template?.code }}
                </span>
              </div>
              <!-- PDF -->
              <div class="form-key-h mt-2">
                <label class="form-template-label"><strong>PDF:</strong></label>
                <input
                  class="form-control input-mango-form"
                  type="text"
                  placeholder="Template"
                  formControlName="pdf"
                  *ngIf="editActive || isNewForm"
                />
                <span *ngIf="!editActive && !isNewForm">
                  {{ elementSelected?.template?.pdf }}
                </span>
              </div>
            </mat-expansion-panel>
          </div>
        </div>

        <!-- WEBHOOKS -->
        <div formArrayName="webhooks">
          <div class="initial-form">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="title-templates">
                  <strong>Webhooks</strong>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div
                class="webhook-container"
                *ngFor="let webhook of webhooks.controls; let i = index"
                [formGroupName]="i"
              >
                <!-- LABEL -->
                <div class="form-key-h mt-2">
                  <label class="form-webhook-label"
                    ><strong>Label:</strong></label
                  >
                  <input
                    class="form-control input-mango-form"
                    type="text"
                    placeholder="My Webhook"
                    formControlName="label"
                    *ngIf="editActive || isNewForm"
                  />
                  <span *ngIf="!editActive && !isNewForm">
                    {{ elementSelected?.webhooks[i]?.label }}
                  </span>
                </div>
                <!-- METHOD -->
                <div class="form-key-h mt-2">
                  <label class="form-webhook-label"
                    ><strong>Method:</strong></label
                  >
                  <select
                    class="form-control input-mango-form"
                    formControlName="method"
                    *ngIf="editActive || isNewForm"
                  >
                    <option value="" disabled selected>Select</option>
                    <option
                      *ngFor="let method of apiMethods"
                      [value]="method?.toLowerCase()"
                    >
                      {{ method?.toUpperCase() }}
                    </option>
                  </select>
                  <span *ngIf="!editActive && !isNewForm">
                    {{ elementSelected?.webhooks[i]?.method?.toUpperCase() }}
                  </span>
                </div>
                <!-- URL -->
                <div class="form-key-h mt-2">
                  <label class="form-webhook-label"
                    ><strong>URL:</strong></label
                  >
                  <input
                    class="form-control input-mango-form"
                    type="text"
                    placeholder="https://webhookurl.com"
                    formControlName="url"
                    *ngIf="editActive || isNewForm"
                  />
                  <span *ngIf="!editActive && !isNewForm">
                    {{ elementSelected?.webhooks[i]?.url }}
                  </span>
                </div>
                <!-- EVENTS -->
                <div class="form-key-h mt-2">
                  <label class="form-webhook-label" for=""
                    ><strong>Launch On</strong></label
                  >
                  <ng-select
                    *ngIf="editActive || isNewForm"
                    formControlName="events"
                    [items]="webhookEvents"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="Select"
                    [multiple]="true"
                    [clearable]="false"
                  ></ng-select>
                  <div *ngIf="!editActive && !isNewForm">
                    <div
                      *ngIf="
                        elementSelected.webhooks[i].events &&
                        elementSelected.webhooks[i].events.length > 0
                      "
                    >
                      <span
                        *ngFor="let tag of elementSelected.webhooks[i].events"
                        class="tag"
                        >{{ getWebhookEventNameById(tag) }}</span
                      >
                    </div>
                    <div
                      *ngIf="
                        !elementSelected.webhooks[i].events ||
                        elementSelected.webhooks[i].events.length == 0
                      "
                    >
                      <span>Never</span>
                    </div>
                  </div>
                </div>
                <!-- HEADERS -->
                <div class="form-key-h mt-2">
                  <label class="form-webhook-label"
                    ><strong>Headers:</strong></label
                  >
                  <textarea
                    class="form-control input-mango-form"
                    placeholder=""
                    formControlName="headers"
                    *ngIf="editActive || isNewForm"
                    rows="5"
                  ></textarea>
                  <span *ngIf="!editActive && !isNewForm">
                    {{
                      stringToJson(elementSelected?.webhooks[i]?.headers) | json
                    }}
                  </span>
                </div>
                <div class="webhook-actions-container">
                  <button
                    (click)="removeWebhook(i)"
                    style="margin-left: auto"
                    *ngIf="editActive"
                    class="btn-style btn-danger flex justify-content-center align-items-center me-1"
                  >
                    <span class="material-symbols-outlined icon-style">
                      delete
                    </span>
                    <span class="text-sm">Remove</span>
                  </button>
                </div>
              </div>
              <button
                (click)="addWebhook()"
                *ngIf="editActive"
                class="btn-style flex justify-content-center align-items-center me-1"
              >
                <span class="material-symbols-outlined icon-style"> add </span>
                <span class="text-sm">Add Webhook</span>
              </button>
            </mat-expansion-panel>
          </div>
        </div>
      </div>
    </div>

    <!-- NO PAGE -->
    <div
      *ngIf="isPreview && elementSelected.layout.length == 0"
      class="mg-no-page-container"
    >
      <span class="material-symbols-outlined mg-no-page-icon"> list_alt </span>
      <!--  <mat-icon class="">list_alt_add</mat-icon> -->
      <span class="mg-no-page-text">
        No layout found. Please create a page
      </span>
    </div>

    <!-- PREVIEW  -->
    <div
      [ngClass]="{
        hide: !this.isPreview || elementSelected.layout.length == 0
      }"
    >
      <mng-fill-form [inputProperties]="formOptions"></mng-fill-form>
    </div>
  </div>

  <div class="open_panel" *ngIf="!openPanel">
    <button (click)="openPanel = !openPanel">
      <mat-icon>arrow_back_ios</mat-icon>
    </button>
  </div>

  <div class="config close" [ngClass]="{ open: openPanel }">
    <div class="title">
      <span class="text_title">Theme</span>
      <div class="close">
        <mat-icon (click)="openPanel = !openPanel">close</mat-icon>
      </div>
    </div>
    <!-- HEADER -->
    <div class="header">
      <span class="text_title">Header Image</span>
      <img
        *ngIf="formGroup.get('config.header').value"
        [src]="formGroup.get('config.header').value"
        class="img-header"
        alt=""
      />
      <button
        class="button_upload"
        (click)="openModalLoadImage()"
        [disabled]="!editActive && !isNewForm"
      >
        <mat-icon class="material-icons-outlined">add_photo_alternate</mat-icon>
        <span>Upload Image</span>
      </button>
    </div>

    <div class="" formGroupName="config">
      <!-- HEADER STYLE -->
      <div class="text_style">
        <span class="text_title">Header Layout </span>
        <div class="dropdown">
          <ng-select
            formControlName="header_layout"
            [readonly]="!editActive && !isNewForm"
          >
            <ng-option
              *ngFor="let layout of headersLayouts"
              [value]="layout.key"
            >
              {{ layout.label }}
            </ng-option>
          </ng-select>
        </div>
      </div>

      <!-- TEXT STYLE -->
      <div class="text_style">
        <span class="text_title">Text Style </span>
        <div class="dropdown">
          <ng-select
            placeholder="Select an option"
            [items]="fonts"
            formControlName="text_style"
            [readonly]="!editActive && !isNewForm"
          ></ng-select>
        </div>
      </div>

      <!-- COLOR -->
      <div class="color">
        <span class="text_title">Color</span>
        <div
          class="color"
          [ngClass]="{ 'disabled-color': !editActive && !isNewForm }"
        >
          <input
            [(colorPicker)]="color"
            [style.background]="color"
            [cpToggle]="true"
            (colorPickerChange)="colorPickerChange($event)"
            [cpDialogDisplay]="'inline'"
            [cpCancelButton]="false"
            [cpDisableInput]="false"
            [disabled]="!editActive && !isNewForm"
            [ngStyle]="{
              display: !editActive && !isNewForm ? 'block' : 'none'
            }"
          />
        </div>
      </div>

      <!-- ADVANCED-->
      <div class="advanced">
        <span class="text_title">Advanced</span>
        <button
          class="button_upload"
          (click)="openModalConfigCss()"
          [disabled]="!editActive && !isNewForm"
        >
          <mat-icon class="material-icons-outlined">code</mat-icon>
          <span>CSS Config</span>
        </button>
      </div>
    </div>
  </div>
</form>
